import { categories } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const handleExternalLink = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20fashion%20and%20lifestyle%20items%20floating%20in%20an%20organized%20grid%20pattern%20against%20a%20warm%20sand%20colored%20background%2C%20soft%20morning%20light%20creating%20gentle%20gradients%2C%20items%20including%20sneakers%20bags%20watches%20and%20clothing%20arranged%20in%20editorial%20catalog%20style%2C%20clean%20modern%20aesthetic%20with%20plenty%20of%20negative%20space%2C%20commercial%20photography%20with%20warm%20neutral%20tones&width=1600&height=900&seq=hero-mulebuy-x02&orientation=landscape"
          alt="Mulebuy Spreadsheet fashion products collection"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="container-site relative z-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
          <div className="w-full lg:w-[60%]">
            <span className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm text-foreground-800 text-xs md:text-sm font-medium px-4 py-2 rounded-full">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              Updated June 2026
            </span>

            <h1 className="mt-6 text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-[1.05]">
              Best Mulebuy
              <br />
              Spreadsheet
              <br />
              2026
            </h1>

            <p className="mt-5 text-white/80 text-sm md:text-base max-w-lg leading-relaxed">
              Discover the latest Mulebuy Spreadsheet featuring trusted sellers,
              verified products, quality checks, and updated finds for sneakers,
              streetwear, bags, watches, and fashion items.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => handleExternalLink("https://kaspreadsheet.com")}
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3.5 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors duration-200"
              >
                Mulebuy Spreadsheet
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </button>
              <button
                onClick={() => handleExternalLink("https://kaspreadsheet.com")}
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-accent-500 text-white px-6 py-3.5 rounded-full font-semibold text-sm hover:bg-accent-600 transition-colors duration-200"
              >
                Buy It Now
                <i className="ri-shopping-bag-line w-4 h-4 flex items-center justify-center"></i>
              </button>
              <Link
                to="/mulebuy-spreadsheet-guide"
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white border border-white/30 px-6 py-3.5 rounded-full font-medium text-sm hover:bg-white/30 transition-colors duration-200"
              >
                Read Guide
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>

          <div className="w-full lg:w-[40%] mt-6 lg:mt-20">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 md:p-6 border border-white/20">
              <div className="flex flex-wrap gap-2">
                {["Updated Daily", "QC Verified Products", "Trusted Sellers", "Safe Buying Guides", "Worldwide Shipping"].map((item) => (
                  <span key={item} className="inline-flex items-center gap-1.5 text-white/90 text-xs bg-white/15 rounded-full px-3 py-1.5">
                    <i className="ri-check-line w-3 h-3 flex items-center justify-center text-accent-400"></i>
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}